export const CommonFunctionsCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Funzioni',
    path: '/sistema/funzioni',
  },
];
